import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CashbookQueryCriteriaClass extends BaseCriteriaModel {
  // Header table
  glcode_guid?: Optional<string> = Optional.empty();
  comp_guid?: Optional<string> = Optional.empty();
  branch_guid?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  // Ext table
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  ext_option?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class CashbookCriteriaModelQuery {
  query = '';

  constructor(cashbookCriteriaModel: CashbookQueryCriteriaClass) {

    if (!cashbookCriteriaModel) {
      return;
    }

    this.query += cashbookCriteriaModel.glcode_guid.filter(x => x !== '').map(x => '&glcode_guid=' + x).orElse('');
    this.query += cashbookCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += cashbookCriteriaModel.branch_guid.filter(x => x !== '').map(x => '&branch_guid=' + x).orElse('');
    this.query += cashbookCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += cashbookCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += cashbookCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += cashbookCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += cashbookCriteriaModel.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += cashbookCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += cashbookCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += cashbookCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += cashbookCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += cashbookCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += cashbookCriteriaModel.value_numeric.filter(x => x != null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + cashbookCriteriaModel.status;
    this.query += '&orderBy=' + cashbookCriteriaModel.orderBy;
    this.query += '&order=' + cashbookCriteriaModel.order;
    this.query += '&offset=' + cashbookCriteriaModel.offset + '&limit=' + cashbookCriteriaModel.limit;
  }
}
